import { formatCurrency } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { truncateNumber } from './utils';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  convertDollar(value?: number): string {
    if (value) {
      const vl = value;
      const f = formatCurrency(
        truncateNumber(vl, 2),
        this.locale,
        '$',
        'USD',
        '1.2-2',
      );
      return f.toString();
    }

    return '$0.00';
  }
}
